<template>
  <div>
    <b-card class="mb-0" no-body>
      <template #header>
        <div class=" d-flex justify-content-start" style="align-items: center;">
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-secondary"
            class="d-flex"
            style="align-items:center;"
            @click="back()"
          >
            <feather-icon icon="ArrowLeftCircleIcon" class="mr-50" size="23" />
            <span class="align-middle">{{ $t("general_buttons.back") }}</span>
          </b-button>
          <h4 class="mb-0 ml-2">
            {{ $t("fx_spot_forward_swap.titles.selected_amend_details") }}
          </h4>
        </div>
      </template>
      <b-overlay :show="loading" rounded="sm" no-fade>
        <b-table
          v-if="tradeDetailDatas.length > 0"
          hover
          ref="refFxExecuteTable"
          class="compact_table"
          thead-class="animate__animated animate__fadeIn"
          :items="tradeDetailDatas"
          :filter="filter"
          filter-debounce="250"
          @filtered="onFiltered"
          :filter-included-fields="filterOn"
          selectable
          select-mode="single"
          responsive
          :small="true"
          head-variant="dark"
          :fields="tableColumns"
          show-empty
          :empty-text="
            $t('fx_spot_forward_swap.messages.no_matching_trade_records')
          "
          :current-page="currentPage"
          :per-page="perPage"
          :tbody-tr-class="legendClass"
          @row-clicked="viewSelectedTrade"
          caption-top
        >
          <!-- Column: show_details -->
          <!-- <template #cell(show_details)="row">
              <b-form-checkbox
                size="md"
                v-model="row.detailsShowing"
                @change="row.toggleDetails"
                name="check-button"
                button
                v-b-tooltip.hover
                :title="
                  row.detailsShowing
                    ? 'Hide Trade Controls'
                    : 'Show Trade Controls'
                "
                button-variant="flat-primary"
              >
                <feather-icon
                  :icon="row.detailsShowing ? 'EyeOffIcon' : 'EyeIcon'"
                />
              </b-form-checkbox>
            </template> -->

          <!-- ID -->
          <template #cell(ID)="data">
            <b
              ><span class="font-weight-bold text-center">
                <strong>{{ data.item.ID ? data.item.ID : "-" }}</strong>
              </span></b
            >
          </template>

          <!-- Column: EntryType -->
          <template #cell(EntryType)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.EntryType ? data.item.EntryType : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: SCF UTI -->
          <template #cell(TcUti)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{ data.item.TcUti ? data.item.TcUti : "-" }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Counterparty -->
          <template #cell(Cpty)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{ data.item.Cpty ? data.item.Cpty : "-" }}</strong>
              </span></b
            >
          </template>

          <!-- Column: OrderDate -->
          <template #cell(OrderDate)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.OrderDate ? dateFormat(data.item.OrderDate) : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: TradeDate -->
          <template #cell(TradeDate)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.TradeDate ? dateFormat(data.item.TradeDate) : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: SettlDate -->
          <template #cell(SettlDate)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.SettlDate ? dateFormat(data.item.SettlDate) : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: ProductType -->
          <template #cell(ProductType)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.ProductType ? data.item.ProductType : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: CcyPair -->
          <template #cell(CcyPair)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{ data.item.Ccy1 + "" + data.item.Ccy2 }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Client -->
          <template #cell(Client)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{ data.item.Client ? data.item.Client : "-" }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Client buy Amount -->
          <template #cell(ClientAmount1)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.ClientAmount1
                    ? formatPrice(data.item.ClientAmount1, 2)
                    : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Client Buy Ccy -->
          <template #cell(Ccy1)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{ data.item.Ccy1 ? data.item.Ccy1 : "-" }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Client sell Amount -->
          <template #cell(ClientAmount2)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.ClientAmount2
                    ? formatPrice(data.item.ClientAmount2, 2)
                    : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Client Sell Ccy -->
          <template #cell(Ccy2)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{ data.item.Ccy2 ? data.item.Ccy2 : "-" }}</strong>
              </span></b
            >
          </template>

          <!-- Column: ClientRate -->
          <template #cell(ClientRate)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.ClientRate
                    ? Number(data.item.ClientRate).toFixed(4)
                    : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: sfc buy amount -->
          <template #cell(CptyAmount1)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.CptyAmount1
                    ? formatPrice(data.item.CptyAmount1, 2)
                    : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: SFC buy ccy -->
          <template #cell(sfcBuyCcy)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{ data.item.Ccy1 ? data.item.Ccy1 : "-" }}</strong>
              </span></b
            >
          </template>

          <!-- Column: sfc sell amount -->
          <template #cell(CptyAmount2)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.CptyAmount2
                    ? formatPrice(data.item.CptyAmount2, 2)
                    : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: SFC sell ccy -->
          <template #cell(sfcSellCcy)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{ data.item.Ccy2 ? data.item.Ccy2 : "-" }}</strong>
              </span></b
            >
          </template>

          <!-- Column: SFC Rate -->
          <template #cell(CptyRate)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.CptyRate
                    ? Number(data.item.CptyRate).toFixed(4)
                    : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Rebate -->
          <template #cell(Rebate)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.Rebate ? data.item.Rebate + "%" : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: SpreadAmount -->
          <template #cell(SpreadAmount)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.SpreadAmount
                    ? formatPrice(data.item.SpreadAmount, 2)
                    : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: SpreadCcy -->
          <template #cell(SpreadCcy)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.SpreadCcy ? data.item.SpreadCcy : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Spread -->
          <template #cell(Spread)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.Spread ? formatPrice(data.item.Spread, 2) : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: CommAmount -->
          <template #cell(CommAmount)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.CommAmount
                    ? formatPrice(data.item.CommAmount, 2)
                    : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: CommCcy -->
          <template #cell(CommCcy)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.CommCcy ? data.item.CommCcy : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: CptyAcc -->
          <template #cell(CptyAcc)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.CptyAcc ? data.item.CptyAcc : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: ClientAcc -->
          <template #cell(ClientAcc)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.ClientAcc ? data.item.ClientAcc : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: CptyTrader -->
          <template #cell(CptyTrader)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.CptyTrader ? data.item.CptyTrader : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: TcUser -->
          <template #cell(TcUser)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{ data.item.TcUser ? data.item.TcUser : "-" }}</strong>
              </span></b
            >
          </template>

          <!-- Column: SpotRef -->
          <template #cell(SpotRef)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.SpotRef ? Number(data.item.SpotRef).toFixed(4) : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: SettlementType -->
          <template #cell(SettlementType)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.SettlementType ? data.item.SettlementType : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: CutOffTime -->
          <template #cell(CutOffTime)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.CutOffTime ? data.item.CutOffTime : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: DeliverableCcy -->
          <!-- <template #cell(DeliverableCcy)="data">
              <b
                ><span class="font-weight-bold">
                  <strong>{{
                    data.item.DeliverableCcy
                      ? data.item.DeliverableCcy
                      : "-"
                  }}</strong>
                </span></b
              >
            </template> -->

          <!-- Column: ConfirmationTrader -->
          <template #cell(ConfirmationTrader)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.ConfirmationTrader
                    ? data.item.ConfirmationTrader
                    : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: CptyUti -->
          <template #cell(CptyUti)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.CptyUti ? data.item.CptyUti : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: UniqueLinkId -->
          <template #cell(UniqueLinkId)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.UniqueLinkId ? data.item.UniqueLinkId : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: ClearingMemberId -->
          <template #cell(ClearingMemberId)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.ClearingMemberId ? data.item.ClearingMemberId : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: CpRef -->
          <template #cell(CpRef)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{ data.item.CpRef ? data.item.CpRef : "-" }}</strong>
              </span></b
            >
          </template>

          <!-- Column: OrderTime -->
          <template #cell(OrderTime)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.OrderTime ? timeFormat(data.item.OrderTime) : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: ExecutionTime -->
          <template #cell(ExecutionTime)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.ExecutionTime
                    ? timeFormat(data.item.ExecutionTime)
                    : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: OrderTakenVia -->
          <template #cell(TakenVia)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.TakenVia ? data.item.TakenVia : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: OrderGivenThrough -->
          <template #cell(GivenThrg)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.GivenThrg ? data.item.GivenThrg : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: ActingCapacity -->
          <template #cell(ActingCap)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.ActingCap ? data.item.ActingCap : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: TraderNote -->
          <template #cell(TraderNote)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.TraderNote ? data.item.TraderNote : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: SavedBy -->
          <template #cell(SavedBy)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.SavedBy ? data.item.SavedBy : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: SaveDate -->
          <template #cell(SaveDate)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.SaveDate != "1900-01-01 00:00:00"
                    ? dateFormat(data.item.SaveDate)
                    : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: SaveTime -->
          <template #cell(SaveTime)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.SaveTime != "1900-01-01 00:00:00"
                    ? timeFormat(data.item.SaveTime)
                    : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: AmendedBy -->
          <template #cell(AmendedBy)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.AmendedBy ? data.item.AmendedBy : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: AmendmentDate -->
          <template #cell(AmendmentDate)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.AmendmentDate != "1900-01-01 00:00:00"
                    ? dateFormat(data.item.AmendmentDate)
                    : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: AmendmentTime -->
          <template #cell(AmendmentTime)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.AmendmentTime != "1900-01-01 00:00:00"
                    ? timeFormat(data.item.AmendmentTime)
                    : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: AmendmentReason -->
          <template #cell(AmendmentReason)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.AmendmentReason ? data.item.AmendmentReason : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: EntryType2 & Main Entry -->
          <template #cell(EntryType2)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{ "Main Entry" }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Cancelled -->
          <template #cell(Cancelled)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.Cancelled == 1 ? "Cancelled" : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: CancelledBy -->
          <template #cell(CancelledBy)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.CancelledBy ? data.item.CancelledBy : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: CancelDate -->
          <template #cell(CancelDate)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.CancelDate != "1900-01-01 00:00:00"
                    ? dateFormat(data.item.CancelDate)
                    : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: CancelTime -->
          <template #cell(CancelTime)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.CancelTime != "1900-01-01 00:00:00"
                    ? timeFormat(data.item.CancelTime)
                    : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: CancelReason -->
          <template #cell(CancelReason)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.CancelReason ? data.item.CancelReason : "-"
                }}</strong>
              </span></b
            >
          </template>
        </b-table>

        <div class="mx-2 mb-2" v-if="tradeDetailDatas.length > 0">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted" style="font-size:0.8rem"
                >{{ $t("general_text.showing") }} {{ dataMeta.from }}
                {{ $t("general_text.to") }} {{ dataMeta.to }}
                {{ $t("general_text.of") }} {{ dataMeta.of }}
                {{ $t("general_text.entries") }}</span
              >
            </b-col>

            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0 compact_paginate"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="14" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="14" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>

        <div v-if="tradeDetailDatas.length == 0">
          <b-alert variant="info" show>
            <div class="alert-body text-center">
              <span
                ><strong>{{
                  $t("fx_spot_forward_swap.titles.not_found_trades")
                }}</strong>
                <br />
                {{
                  $t("fx_spot_forward_swap.messages.no_amended_trades_found")
                }}</span
              >
            </div>
          </b-alert>
        </div>
      </b-overlay>

      {{ /*View Selected Trade for trades modal*/ }}
      <ViewSelectedTrade ref="ViewSelectedTrade" />
    </b-card>
  </div>
</template>

<script>
import {
  BOverlay,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormRating,
  VBModal,
  BTabs,
  BTab,
  BCardText,
  BIcon,
  BPopover,
} from "bootstrap-vue";
import store from "@/store";
import { onUnmounted } from "@vue/composition-api";
import fXSpotForwardSwapStoreModule from "../FXSpotForwardSwapStoreModule";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, alphaNum, email } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import axios from "axios";
import axiosIns from "@/libs/axios";
import router from "@/router";
import moment from "moment";
import "animate.css";
import _ from "lodash";
import { mapState, mapGetters } from "vuex";
import ViewSelectedTrade from "./ViewSelectedDetail.vue";

export default {
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BTabs,
    BTab,
    BCardText,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormRating,
    BIcon,
    BPopover,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    ToastificationContent,
    flatPickr,
    ViewSelectedTrade,
  },

  directives: {
    Ripple,
    "b-modal": VBModal,
  },

  setup() {
    const FXSPOTFORWARDSWAP_APP_STORE_MODULE_NAME = "fxSFS";
    // Register module
    if (!store.hasModule(FXSPOTFORWARDSWAP_APP_STORE_MODULE_NAME))
      store.registerModule(
        FXSPOTFORWARDSWAP_APP_STORE_MODULE_NAME,
        fXSpotForwardSwapStoreModule
      );

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(FXSPOTFORWARDSWAP_APP_STORE_MODULE_NAME))
        store.unregisterModule(FXSPOTFORWARDSWAP_APP_STORE_MODULE_NAME);
    });
  },

  mounted() {
    this.detailId = this.$route.params.id;
    this.getAmendDetailsData(this.$route.params.id);
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  data() {
    return {
      tradeDetailDatas: [],
      detailId: null,
      filterOn: [
        "TcUser",
        "Cpty",
        "Client",
        "OrderGivenThrough",
        "OrderTakenVia",
      ],
      tableColumns: [
        // { key: "show_details", label: "" },
        {
          key: "id",
          label: "ID",
          // thClass: "text-left",
          tdClass: "text-center",
          // thStyle: 'width: 30%',
          sortable: true,
          class: "text-start table-padding",
          variant: "primary",
        },
        {
          key: "EntryType",
          label: this.$t("fx_spot_forward_swap.table.entry_type"),
          class: "text-start table-padding",
        },
        {
          key: "TcUti",
          label: this.$t("fx_spot_forward_swap.table.sfc_uti"),
          class: "text-start table-padding",
        },
        {
          key: "Cpty",
          label: this.$t("fx_spot_forward_swap.table.counterparty"),
          class: "text-start table-padding",
        },
        {
          key: "OrderDate",
          label: this.$t("fx_spot_forward_swap.table.order_date"),
          class: "text-start table-padding",
        },
        {
          key: "TradeDate",
          label: this.$t("fx_spot_forward_swap.table.trade_date"),
          class: "text-start table-padding",
          sortable: true,
        },

        {
          key: "SettlDate",
          label: this.$t("fx_spot_forward_swap.table.value_date"),
          class: "text-start table-padding",
          sortable: true,
        },
        {
          key: "ProductType",
          label: this.$t("fx_spot_forward_swap.table.product_type"),
          class: "text-start table-padding",
        },
        {
          key: "CcyPair",
          label: this.$t("fx_spot_forward_swap.table.ccy_pair"),
          class: "text-start table-padding",
        },

        {
          key: "Client",
          label: this.$t("fx_spot_forward_swap.table.client"),
          class: "text-start table-padding",
        },

        {
          key: "ClientAmount1",
          label: this.$t("fx_spot_forward_swap.table.client_buy_amount"),
          class: "text-start table-padding",
          sortable: true,
        },
        {
          key: "Ccy1",
          label: this.$t("fx_spot_forward_swap.table.client_buy_ccy"),
          class: "text-start table-padding",
        },
        {
          key: "ClientAmount2",
          label: this.$t("fx_spot_forward_swap.table.client_sell_amount"),
          class: "text-start table-padding",
          sortable: true,
        },
        {
          key: "Ccy2",
          label: this.$t("fx_spot_forward_swap.table.client_sell_ccy"),
          class: "text-start table-padding",
        },

        {
          key: "ClientRate",
          label: this.$t("fx_spot_forward_swap.table.client_rate"),
          class: "text-start table-padding",
        },
        {
          key: "CptyAmount1",
          label: this.$t("fx_spot_forward_swap.table.sfc_buy_amount"),
          class: "text-start table-padding",
        },
        {
          key: "sfcBuyCcy",
          label: this.$t("fx_spot_forward_swap.table.sfc_buy_ccy"),
          class: "text-start table-padding",
        },
        {
          key: "CptyAmount2",
          label: this.$t("fx_spot_forward_swap.table.sfc_sell_amount"),
          class: "text-start table-padding",
        },
        {
          key: "sfcSellCcy",
          label: this.$t("fx_spot_forward_swap.table.sfc_sell_ccy"),
          class: "text-start table-padding",
        },
        {
          key: "CptyRate",
          label: this.$t("fx_spot_forward_swap.table.sfc_rate"),
          class: "text-start table-padding",
        },
        {
          key: "Rebate",
          label: this.$t("fx_spot_forward_swap.table.rebate"),
          class: "text-start table-padding",
        },
        {
          key: "SpreadAmount",
          label: this.$t("fx_spot_forward_swap.table.spread_amount"),
          class: "text-start table-padding",
        },

        {
          key: "SpreadCcy",
          label: this.$t("fx_spot_forward_swap.table.spread_ccy"),
          class: "text-start table-padding",
        },

        {
          key: "Spread",
          label: this.$t("fx_spot_forward_swap.table.spread"),
          class: "text-start table-padding",
        },

        {
          key: "CommAmount",
          label: this.$t("fx_spot_forward_swap.table.comm_amount"),
          class: "text-start table-padding",
        },

        {
          key: "CommCcy",
          label: this.$t("fx_spot_forward_swap.table.comm_ccy"),
          class: "text-start table-padding",
        },

        {
          key: "CptyAcc",
          label: this.$t("fx_spot_forward_swap.table.counterparty_account"),
          class: "text-start table-padding",
        },

        {
          key: "ClientAcc",
          label: this.$t("fx_spot_forward_swap.table.client_account"),
          class: "text-start table-padding",
        },

        {
          key: "CptyTrader",
          label: this.$t("fx_spot_forward_swap.table.counterparty_trader"),
          class: "text-start table-padding",
        },
        {
          key: "TcUser",
          label: this.$t("fx_spot_forward_swap.table.sfc_user"),
          class: "text-start table-padding",
          sortable: true,
        },
        {
          key: "SpotRef",
          label: this.$t("fx_spot_forward_swap.table.spot_ref"),
          class: "text-start table-padding",
        },
        {
          key: "SettlementType",
          label: this.$t("fx_spot_forward_swap.table.settlement_type"),
          class: "text-start table-padding",
        },
        {
          key: "CutOffTime",
          label: this.$t("fx_spot_forward_swap.table.cutt_off_time"),
          class: "text-start table-padding",
        },
        // {
        //   key: "DeliverableCcy",
        //   label: this.$t("fx_spot_forward_swap.table.deliverable_ccy"),
        //   class: "text-start table-padding",
        // },
        {
          key: "ConfirmationTrader",
          label: this.$t("fx_spot_forward_swap.table.confirmation_trader"),
          class: "text-start table-padding",
        },
        {
          key: "CptyUti",
          label: this.$t("fx_spot_forward_swap.table.counterparty_uti"),
          class: "text-start table-padding",
        },
        {
          key: "UniqueLinkId",
          label: this.$t("fx_spot_forward_swap.table.unique_link_id"),
          class: "text-start table-padding",
        },
        {
          key: "ClearingMemberId",
          label: this.$t("fx_spot_forward_swap.table.cliearing_member_id"),
          class: "text-start table-padding",
        },
        {
          key: "CpRef",
          label: this.$t("fx_spot_forward_swap.table.counterparty_ref"),
          class: "text-start table-padding",
        },
        {
          key: "OrderTime",
          label: this.$t("fx_spot_forward_swap.table.order_time"),
          class: "text-start table-padding",
        },
        {
          key: "ExecutionTime",
          label: this.$t("fx_spot_forward_swap.table.execution_time"),
          class: "text-start table-padding",
        },

        {
          key: "TakenVia",
          label: this.$t("fx_spot_forward_swap.table.order_taken_via"),
          class: "text-start table-padding",
        },
        {
          key: "GivenThrg",
          label: this.$t("fx_spot_forward_swap.table.order_given_through"),
          class: "text-start table-padding",
        },

        {
          key: "ActingCap",
          label: this.$t("fx_spot_forward_swap.table.acting_capacity"),
          class: "text-start table-padding",
        },

        {
          key: "TraderNote",
          label: this.$t("fx_spot_forward_swap.table.trader_note"),
          class: "text-start table-padding",
        },
        {
          key: "SavedBy",
          label: this.$t("fx_spot_forward_swap.table.saved_by"),
          class: "text-start table-padding",
        },
        {
          key: "SaveDate",
          label: this.$t("fx_spot_forward_swap.table.save_date"),
          class: "text-start table-padding",
          sortable: true,
        },
        {
          key: "SaveTime",
          label: this.$t("fx_spot_forward_swap.table.save_time"),
          class: "text-start table-padding",
        },
        {
          key: "AmendedBy",
          label: this.$t("fx_spot_forward_swap.table.amended_by"),
          class: "text-start table-padding",
        },
        {
          key: "AmendmentDate",
          label: this.$t("fx_spot_forward_swap.table.amendment_date"),
          class: "text-start table-padding",
          sortable: true,
        },
        {
          key: "AmendmentTime",
          label: this.$t("fx_spot_forward_swap.table.amendment_time"),
          class: "text-start table-padding",
        },
        {
          key: "AmendmentReason",
          label: this.$t("fx_spot_forward_swap.table.amendment_reason"),
          class: "text-start table-padding",
        },
        {
          key: "EntryType2",
          label: this.$t("fx_spot_forward_swap.table.entry_type"),
          class: "text-start table-padding",
        },
        {
          key: "Cancelled",
          label: this.$t("fx_spot_forward_swap.table.cancelled"),
          class: "text-start table-padding",
        },
        {
          key: "CancelledBy",
          label: this.$t("fx_spot_forward_swap.table.cancelled_by"),
          class: "text-start table-padding",
        },
        {
          key: "CancelDate",
          label: this.$t("fx_spot_forward_swap.table.canceled_date"),
          class: "text-start table-padding",
          sortable: true,
        },
        {
          key: "CancelTime",
          label: this.$t("fx_spot_forward_swap.table.cancelled_time"),
          class: "text-start table-padding",
        },
        {
          key: "CancelReason",
          label: this.$t("fx_spot_forward_swap.table.cancelled_reason"),
          class: "text-start table-padding",
        },
      ],

      perPage: 25,
      currentPage: 1,
      totalRows: 0,
      perPageOptions: [10, 25, 50, 100],
      filter: null,
      loading: false,
      filterSettlementDate: null,
      filterTradeDate: null,
      canceledReasonText: null,
    };
  },
  computed: {
    user: {
      get() {
        return this.$store.getters["authUser"];
      },
      set(newValue) {
        return this.$store.dispatch("setUser", newValue);
      },
    },
    dataMeta() {
      return {
        from:
          this.totalRows != 0 ? this.perPage * (this.currentPage - 1) + 1 : 0,
        to:
          this.perPage * (this.currentPage - 1) + Number(this.perPage) <
          this.totalRows
            ? this.perPage * (this.currentPage - 1) + Number(this.perPage)
            : this.totalRows,
        of: this.totalRows,
      };
    },
  },
  methods: {
    back() {
      router.go(-1);
    },
    legendClass(item, type) {
      const executedRowColor = "table-executed";
      const verifiedRowColor = "table-verified";
      const journalCreateRowColor = "table-journalCreate";
      const expiredOrderRowColor = "table-expiredOrder";
      const reversedInitiateRowColor = "table-reverseInitiated";
      const reversedRowColor = "table-reversed";
      const canceledRowColor = "table-canceled";

      if (!item || type !== "row") {
        return;
      }

      if (item.Cancelled == 1) {
        return canceledRowColor;
      }
      if (item.Reversed == 1) {
        return reversedRowColor;
      }
      if (item.ReversalInitiated == 1) {
        return reversedInitiateRowColor;
      }
      if (item.ExpiredOrder == 1) {
        return expiredOrderRowColor;
      }
      if (item.JournalCreated == 1) {
        return journalCreateRowColor;
      }
      if (item.Verified == 1) {
        return verifiedRowColor;
      }
      if (item.EntryType == "Execution") {
        return executedRowColor;
      }
    },
    getAmendDetailsData(id) {
      this.loading = true;
      this.$checkAccessRight("FxExecuted", "View").then((res) => {
        if (res.data.valid) {
          store
            .dispatch("fxSFS/getAmendFxDetailDatas", {
              auth: this.user,
              tradeId: id,
            })
            .then((res) => {
              if (res.data.info == "Pass") {
                // this.tradeDetailDatas.push(res.data.trade);
                if (res.data.details.length > 0) {
                  res.data.details.forEach((data) => {
                    this.tradeDetailDatas.push(data);
                  });
                }
                this.totalRows = this.tradeDetailDatas.length;
                this.loading = false;
              } else {
                this.notFoundMessage();
                this.loading = false;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.loading = false;
        }
      });
    },
    viewSelectedTrade(item) {
      this.$checkAccessRight("FxExecuted", "View").then((res) => {
        if (res.data.valid) {
          if (item.id != 0) {
            if (this.detailId == item.id) {
              store
                .dispatch("fxSFS/getViewSelectedFxTrade", {
                  tradeId: item.id,
                  tcUti: item.TcUti,
                })
                .then((res) => {
                  if (res.data.info == "Pass") {
                    this.$refs.ViewSelectedTrade.viewSelectedTradeModal = true;
                    this.$refs.ViewSelectedTrade.fetchedTradeData =
                      res.data.trade;

                    //set timeline datas
                    let actionsArray = [];
                    if (
                      res.data.trade.SavedBy != null &&
                      res.data.trade.SavedBy != ""
                    ) {
                      actionsArray.push({
                        type: "Saved",
                        user: res.data.trade.SavedBy ?? "",
                        date:
                          res.data.trade.SaveDate.split(" ")[0] +
                          " " +
                          res.data.trade.SaveTime.split(" ")[1],
                        reason: "-",
                      });
                    }

                    if (
                      res.data.trade.AmendedBy != null &&
                      res.data.trade.AmendedBy != ""
                    ) {
                      actionsArray.push({
                        type: "Amended",
                        user: res.data.trade.AmendedBy ?? "",
                        date:
                          res.data.trade.AmendmentDate.split(" ")[0] +
                          " " +
                          res.data.trade.AmendmentTime.split(" ")[1],
                        reason: res.data.trade.AmendmentReason,
                      });
                    }
                    if (res.data.actions.length > 0) {
                      if (
                        res.data.actions[0].VerificationUser != null &&
                        res.data.actions[0].VerificationUser != ""
                      ) {
                        this.$refs.ViewSelectedTrade.checkVerify = true;
                        actionsArray.push({
                          type: "Verified",
                          user: res.data.actions[0].VerificationUser ?? "",
                          date: res.data.actions[0].VerificationDateTime,
                          reason: "-",
                        });
                      }
                    }

                    if (res.data.actions.length > 0) {
                      if (
                        res.data.actions[0].JournalUser != null &&
                        res.data.actions[0].JournalUser != ""
                      ) {
                        actionsArray.push({
                          type: "Journal Created",
                          user: res.data.actions[0].JournalUser ?? "",
                          date: res.data.actions[0].JournalDateTime,
                          reason: "-",
                        });
                      }
                    }

                    if (
                      res.data.trade.CancelledBy != null &&
                      res.data.trade.CancelledBy != ""
                    ) {
                      actionsArray.push({
                        type: "Canceled",
                        user: res.data.trade.CancelledBy ?? "",
                        date:
                          res.data.trade.CancelDate.split(" ")[0] +
                          " " +
                          res.data.trade.CancelTime.split(" ")[1],
                        reason: res.data.trade.CancelReason,
                      });
                    }

                    if (res.data.actions.length > 0) {
                      if (
                        res.data.actions[0].ReversalInitiatedBy != null &&
                        res.data.actions[0].ReversalInitiatedBy != ""
                      ) {
                        actionsArray.push({
                          type: "Reversal Initiated",
                          user: res.data.actions[0].ReversalInitiatedBy ?? "",
                          date: res.data.actions[0].ReversalInitiatedDateTime,
                          reason: res.data.actions[0].ReversalInitiatedReason,
                        });
                      }
                    }

                    if (res.data.actions.length > 0) {
                      if (
                        res.data.actions[0].ReversedBy != null &&
                        res.data.actions[0].ReversedBy != ""
                      ) {
                        actionsArray.push({
                          type: "Reversed",
                          user: res.data.actions[0].ReversedBy ?? "",
                          date: res.data.actions[0].ReversedDateTime,
                          reason: "-",
                        });
                      }
                    }

                    this.$refs.ViewSelectedTrade.actionsData = actionsArray;
                  } else {
                    this.notFoundMessage();
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            } else {
              store
                .dispatch("fxSFS/getViewAmendedFxSelectedTrade", {
                  tradeId: item.id,
                  tcUti: item.TcUti,
                })
                .then((res) => {
                  if (res.data.info == "Pass") {
                    this.$refs.ViewSelectedTrade.viewSelectedTradeModal = true;
                    this.$refs.ViewSelectedTrade.fetchedTradeData =
                      res.data.trade;

                    // set changes red color inputs
                    if (res.data.changedInputs) {
                      let setChangedInputs = _.map(
                        res.data.changedInputs,
                        (value, key) => ({ key, value })
                      );

                      if (setChangedInputs.length > 0) {
                        this.$refs.ViewSelectedTrade.changedInputs = setChangedInputs;
                      }
                    }

                    //set timeline datas
                    let actionsArray = [];
                    if (
                      res.data.trade.SavedBy != null &&
                      res.data.trade.SavedBy != ""
                    ) {
                      actionsArray.push({
                        type: "Saved",
                        user: res.data.trade.SavedBy ?? "",
                        date:
                          res.data.trade.SaveDate.split(" ")[0] +
                          " " +
                          res.data.trade.SaveTime.split(" ")[1],
                        reason: "-",
                      });
                    }

                    if (
                      res.data.trade.AmendedBy != null &&
                      res.data.trade.AmendedBy != ""
                    ) {
                      actionsArray.push({
                        type: "Amended",
                        user: res.data.trade.AmendedBy ?? "",
                        date:
                          res.data.trade.AmendmentDate.split(" ")[0] +
                          " " +
                          res.data.trade.AmendmentTime.split(" ")[1],
                        reason: res.data.trade.AmendmentReason,
                      });
                    }
                    if (res.data.actions.length > 0) {
                      if (
                        res.data.actions[0].VerificationUser != null &&
                        res.data.actions[0].VerificationUser != ""
                      ) {
                        this.$refs.ViewSelectedTrade.checkVerify = true;
                        actionsArray.push({
                          type: "Verified",
                          user: res.data.actions[0].VerificationUser ?? "",
                          date: res.data.actions[0].VerificationDateTime,
                          reason: "-",
                        });
                      }
                    }

                    if (res.data.actions.length > 0) {
                      if (
                        res.data.actions[0].JournalUser != null &&
                        res.data.actions[0].JournalUser != ""
                      ) {
                        actionsArray.push({
                          type: "Journal Created",
                          user: res.data.actions[0].JournalUser ?? "",
                          date: res.data.actions[0].JournalDateTime,
                          reason: "-",
                        });
                      }
                    }

                    if (
                      res.data.trade.CancelledBy != null &&
                      res.data.trade.CancelledBy != ""
                    ) {
                      actionsArray.push({
                        type: "Canceled",
                        user: res.data.trade.CancelledBy ?? "",
                        date:
                          res.data.trade.CancelDate.split(" ")[0] +
                          " " +
                          res.data.trade.CancelTime.split(" ")[1],
                        reason: res.data.trade.CancelReason,
                      });
                    }

                    if (res.data.actions.length > 0) {
                      if (
                        res.data.actions[0].ReversalInitiatedBy != null &&
                        res.data.actions[0].ReversalInitiatedBy != ""
                      ) {
                        actionsArray.push({
                          type: "Reversal Initiated",
                          user: res.data.actions[0].ReversalInitiatedBy ?? "",
                          date: res.data.actions[0].ReversalInitiatedDateTime,
                          reason: res.data.actions[0].ReversalInitiatedReason,
                        });
                      }
                    }

                    if (res.data.actions.length > 0) {
                      if (
                        res.data.actions[0].ReversedBy != null &&
                        res.data.actions[0].ReversedBy != ""
                      ) {
                        actionsArray.push({
                          type: "Reversed",
                          user: res.data.actions[0].ReversedBy ?? "",
                          date: res.data.actions[0].ReversedDateTime,
                          reason: "-",
                        });
                      }
                    }

                    this.$refs.ViewSelectedTrade.actionsData = actionsArray;
                  } else {
                    this.notFoundMessage();
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          } else {
            this.tradeIDDoesntZeroMessage();
          }
        } else {
          this.notAuthToastMessage();
        }
      });
    },

    databaseErrorMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: this.$t(
            "fx_spot_forward_swap.toast_messages.database_connection_error"
          ),
          icon: "AlertTriangleIcon",
          variant: "danger",
        },
      });
    },
    errorMessage(message) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: message,
          icon: "AlertTriangleIcon",
          variant: "danger",
        },
      });
    },
    notFoundMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Not Found",
          text: this.$t("fx_spot_forward_swap.toast_messages.data_not_found"),
          icon: "AlertTriangleIcon",
          variant: "warning",
        },
      });
    },
    wrongToastMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: val,
          icon: "AlertTriangleIcon",
          variant: "warning",
        },
      });
    },
    notAuthToastMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Not Authorized",
          text: this.$t(
            "fx_spot_forward_swap.general_messages.not_authorized_message"
          ),
          icon: "UserXIcon",
          variant: "warning",
        },
      });
    },

    tradeIDDoesntZeroMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Warning",
          text: this.$t("fx_spot_forward_swap.messages.trade_id_cannot_zero"),
          icon: "AlertTriangleIcon",
          variant: "warning",
        },
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    dateFormat(val) {
      if (val != undefined) {
        return moment(String(val)).format("DD-MM-YYYY");
      }
    },
    dateFormatWithTime(val) {
      if (val != undefined) {
        return moment(String(val)).format("MM-DD-YYYY HH:mm:ss");
      }
    },
    DMYdateFormat(val) {
      if (val != undefined) {
        return moment(String(val), "DD-MM-YYYY").format("DD-MM-YYYY");
      }
    },
    timeFormat(val) {
      if (val != undefined) {
        return moment(String(val)).format("HH:mm:ss");
      }
    },
    formatPrice(value, val) {
      if (value != null) {
        let val = (value / 1).toFixed(2).replace(",", ".");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    YMDdateFormat(val) {
      if (val != undefined) {
        return moment(String(val), "DD-MM-YYYY").format("YYYY-MM-DD");
      }
    },
    clearTradeDate() {
      this.filterTradeDate = null;
      this.runLastSearch();
    },
    clearSettlementDate() {
      this.filterSettlementDate = null;
      this.runLastSearch();
    },
    handleScroll(e) {
      // this.windowTop = window.top.scrollY
      // if(this.windowTop > 300) {
      //   console.log(this.$refs.refFxExecuteTable.$el)
      // }
    },
  },
  watch: {
    perPage: {
      handler: function(val, before) {
        localStorage.setItem("AmendDetailsShow", val);
      },
    },
  },
};
</script>

<style>
.top-btns {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.table-executed {
  background-color: #e9fafa !important;
}
.table-verified {
  background-color: #00ff7f !important;
}
.table-journalCreate {
  background-color: #e1d7f5 !important;
}
.table-expiredOrder {
  background-color: silver !important;
}
.table-reverseInitiated {
  background-color: #ffff99 !important;
}

.table-reversed {
  background-color: #f8ac91 !important;
}

.table-canceled {
  background-color: #ffb8b8 !important;
}

.ID_background {
  background-color: gainsboro !important;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: grey;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgb(77, 73, 73);
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<!-- compact design scss code -->

<style lang="scss" scoped>
@import "~/src/assets/scss/compact-design.scss";

.card::v-deep .card-body {
  padding: 0.8rem 0.7rem !important;

  .card-title {
    font-weight: 500 !important;
    font-size: 1.285rem !important;
    margin-bottom: 0.6rem !important;
    text-decoration: none !important;
  }
}
</style>
